import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const AlertsContainer = styled('div')`
  position: sticky;
  top: 0;
  z-index: 100;
  margin: ${fromTheme('spacing_medium')} auto 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1440px;
  padding: 0 ${fromTheme('spacing_medium')};
`;
